import { lazy, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ARViewer from "./components/SmartObject/ArViewer";
import { AnimatedLoader } from "./components/Loader/ImagineLoader";
export const CONFIGURATOR_VIEWER = "/configurator/:modelId";

const ConfiguratorViewer = lazy(() => import("./components/ConfiguratorViewer/ConfiguratorViewer"));
const SmartObject = lazy(() => import("./components/SmartObject/SmartObject_bullOutdoor"));
// const ARViewer = lazy(() => import("./components/SmartObject/ArViewer"));

const routeMapFunc = (
  { exact = true, path, Component, componentProps, routes },
  idx
) => {
  return (
    <Route
      path={path}
      exact={exact}
      element={<Component {...componentProps} />}
      key={idx}
    >
      {routes?.map(routeMapFunc)}
    </Route>
  );
};

export const routes = [
  { path: CONFIGURATOR_VIEWER, Component: ConfiguratorViewer, key: "viewer" },
  { path: '/', Component: ConfiguratorViewer, key: 'viewer'},
  { path: '/:modelId', Component: SmartObject, key: 'smart',},
  // { path: '/ar/preview/:token', Component: ARViewer, key: 'ARViewer'},
];

export const Routing = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<AnimatedLoader zIndex={1000} loading={true} className="bg-white" position="fixed" />}>
        <Routes>{routes.map(routeMapFunc)}</Routes>
        {/* <Route
          path="/ar/preview/:token"
          element={<ARViewer />}
        /> */}
      </Suspense>
    </ErrorBoundary>
  );
};
